import React, { useCallback, useContext, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
/**Components**/
import "react-js-cron/dist/styles.css";
import Modal from "../../utils/components/common/modal";
import "./ScheduleSetting.scss";

/**Utils**/
import { formatDate } from "../../utils/utils";
import JobList from "./JobList";
import ScheduleSettingEdit from "./ScheduleSettingEdit";
import { UserContext } from "../../layouts/MainLayout";
import { USER_ROLES } from "../../utils/constants/userConstants";

const ScheduleSetting = (props) => {
  const { onCloseModal, isOpen, deviceData, refreshData, isParentLoading } =
    props;
  const [isEdit, setIsEdit] = useState(false);
  const { t } = useTranslation("device");

  /**Context**/
  const { loggedInUserRole } = useContext(UserContext);

  // Close modal
  const onCloseClick = useCallback(() => {
    onCloseModal();
  }, [onCloseModal]);

  const isSchdEnable = useMemo(() => {
    let schdStatus = deviceData ? deviceData?.scheduleStatus || "" : "";
    return schdStatus?.toLowerCase() === "enabled";
  }, [deviceData]);

  const isValidForEdit = useMemo(() => {
    return (
      loggedInUserRole !== USER_ROLES.viewOnlyUserCorp &&
      loggedInUserRole !== USER_ROLES.userCorp
    );
  }, [loggedInUserRole]);

  return (
    <div className="scheduleSettingSection">
      <Modal
        isOpen={isOpen}
        className={`schedulerSettingModal ${isEdit ? "scheduleModalhide" : ""}`}
        idName="schedulerSettingModal"
      >
        {/* Header Starts */}
        <div className="settingHeader">
          <p className="heading-h2 title" id="schd-heading">
            {t("schdSetting.schedule")} {deviceData?.DeviceName}{" "}
          </p>
          <span
            className={`text-h2 cstmBadge scdh-status ${
              isSchdEnable ? "enabled" : ""
            }`}
            id="schd-status"
          >
            {isSchdEnable ? "Enabled" : "Disabled"}
          </span>
        </div>
        {/* Header Ends */}

        {/* Body Container Starts */}
        <div className="schdBody">
          <p className="text-h3 mt-4 mb-3 scheduledSubHead" id="scheduledSubHead">
            {t("schdSetting.scheduledTasks")}
          </p>
          <div className="schdListing">
            {!isParentLoading && (
              <JobList
                listItems={deviceData?.jobList}
                noTaskText={t("schdSetting.noTask")}
                isActionCol={false}
              />
            )}
          </div>
        </div>

        {/* Footer Container Start */}
        <div className="schdSettingFooter">
          <div>
            <div className="createdDetails">
              <span className="label text-h4" id="createdOn">
                {t("schdSetting.savedToDevice")}
                &nbsp;
              </span>
              <span className="value text-h4" id="createdDateTime">
                {deviceData?.schedulePushOn
                  ? formatDate(deviceData?.schedulePushOn, false)
                  : "-"}
              </span>
            </div>
            <div className="createdDetails">
              <span className="label text-h4" id="createdBy">
                {t("schdSetting.savedToDeviceBy")}
                &nbsp;
              </span>
              <span className="value text-h4" id="createdByUserEmail">
                {deviceData?.schedulePushedByEmail ?? "-"}
              </span>
            </div>
          </div>
          <div className="btnGroup">
            <button
              id="closeBtn"
              className="roundBtn dark"
              onClick={onCloseClick}
            >
              <span>{t("schdSetting.close")}</span>
            </button>
            <button
              id="editBtn"
              className="roundBtn primary"
              disabled={!isValidForEdit}
              onClick={() => {
                setIsEdit(true);
              }}
            >
              <span>{t("schdSetting.edit")}</span>
            </button>
          </div>
        </div>
      </Modal>

      {/* Edit Schedule Setting Modal Start*/}
      {isEdit && (
        <ScheduleSettingEdit
          isOpen={isEdit}
          onCloseModal={() => {
            refreshData();
            setIsEdit(false);
          }}
          idName="scheduleSettingEditModal"
          deviceData={deviceData}
          isSchdEnable={isSchdEnable}
        />
      )}
    </div>
  );
};

export default ScheduleSetting;
